import { createElement } from 'react';
import { Slider } from '@alifd/next';
import './index.scss';
import { string, number } from 'prop-types';
const Accordion = function Accordion({ style: styleOption = { height: number || string }, tabArr, isCenter, limit, type, isArraw, isDots, isAutoplay }) {
    const settings = {
        className: isCenter ? "custom-slide center" : 'custom-slide',
        centerMode: true,
        infinite: true,
        centerPadding: isCenter ? "60px" : 0,
        slidesToShow: limit,
        speed: 500,
        autoplaySpeed: 3000,
        arrows: isArraw,
        dots: isDots,
        dotsClass: type,
        autoplay: isAutoplay,
        dotsRender: type !== 'none' ? (index) => {
            return createElement("a", null, index);
        } : null
    };
    return (createElement(Slider, { ...settings, style: { padding: isCenter ? '20px 0' : '', height: 'auto', ...styleOption } }, tabArr.map(item => createElement("div", null,
        createElement("div", { className: "ctn", style: { height: styleOption.height || '300px' } }, item.content)))));
};
export default Accordion;
